import _ from 'lodash';
import { Locale, SegmentConfig } from './type';

const equity = ['item0.equity']
const fno = ['item0.month1Price']

export const buildIndicatorDefaultValues = () => {
  const locale = _.get(window, 'SA_LOCALE.locale', 'in').toLowerCase();
  return {
    getValuePaths: () => {
      if (locale === Locale.CRYPTO) return fno;

      return equity;
    },
    getValuePathSupportedSegments: (excludedSegments: SegmentConfig) => {
      const allSegments = [SegmentConfig.equity, SegmentConfig.future, SegmentConfig.option];

      return allSegments.filter((segment) => !excludedSegments || segment !== excludedSegments);
    },
  };
};
